import {
  List,
  ListItem,
  ListItemText,
  Tooltip
} from "@mui/material"

//=================================================
// EC2 Columns
//================================================= 
// Inventory Report
export const ec2ColumnsForInventoryReports = [
  {
    field: 'id',
    headerName: 'Instance ID',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'instanceName',
    headerName: 'Name',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'onDemandPriceValue',
    headerName: 'On Demand cost/hour',
    // width: '200',
    flex: 1,
    align: 'center',
  },
  {
    field: 'duration',
    headerName: 'Stopped hours',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Savings cost',
    // width: '200',
    flex: 1,
    align: 'center'
  },
]

// Inventory Instance Columns
export const ec2ColumnsForDataGrid = [
  {
    field: 'id',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'name',
    headerName: 'Name',
    width: '200',
    align: 'center'
  },
  // {
  //   field: 'instanceID',
  //   headerName: 'Instance ID'
  // },
  {
    field: 'instanceState',
    headerName: 'Instance State',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <span className={`inventory-state-${params.value}`}>{params.value}</span>
    )
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '200',
    align: 'center'
  },
  {
    field: 'tags',
    headerName: 'Tags',
    width: 320,           // Increased width for better visibility
    align: 'left',
    sortable: false,
    valueFormatter: (params) => {
      console.log('params in tags formatter', params)
      const tags = params || [];
      if (!tags.length) return 'No tags';
      return tags.map(tag => `${tag.Key}: ${tag.Value}`).join(' | ');
    },
    renderCell: (params) => {
      const tags = params.value || [];
    
      if (!tags || tags.length === 0) {
        return (
          <span style={{ color: '#9ca3af', fontStyle: 'italic', fontSize: '13px' }}>
            No tags
          </span>
        );
      }
    
      return (
        <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.25rem',
        maxWidth: '100%',
        width: '100%',
        height: '100%',
        alignItems: 'center'
      }}>
        {tags.map((tag, index) => (
          <div
            key={index}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '0.125rem 0.5rem',
              borderRadius: '0.25rem',
              fontSize: '0.75rem',
              fontWeight: 500,
              backgroundColor: '#f3f4f6',
              color: '#374151',
              border: '1px solid #e5e7eb',
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              height: '24px',
              lineHeight: '1',
              flexShrink: 0,
              margin: '2px 0',
            }}
            title={`${tag.Key}: ${tag.Value}`}
          >
            <span style={{ 
              fontWeight: 600, 
              marginRight: '0.25rem', 
              color: '#111827' 
            }}>
              {tag.Key}
            </span>
            <span style={{ color: '#6b7280' }}>
              : {tag.Value}
            </span>
          </div>
        ))}
        </div>
      );
    }
  },
  {
    field: 'publicIPv4DNS',
    headerName: 'Public IPv4 DNS',
    width: '200',
    align: 'center'
  },
  {
    field: 'publicIPv4Address',
    headerName: 'Public IPv4 address',
    width: '200',
    align: 'center'
  },
  {
    field: 'iPv6IPs',
    headerName: 'IPv6 IPs',
    // width: '200',
    align: 'center'
  },
  {
    field: 'monitoring',
    headerName: 'Monitoring',
    // width: '200',
    align: 'center'
  },
  {
    field: 'securityGroupName',
    headerName: 'Security Group Name',
    width: '200',
    align: 'center'
  },
  {
    field: 'keyName',
    headerName: 'Key Name',
    // width: '200',
    align: 'center'
  },
  {
    field: 'launchTime',
    headerName: 'Launch Time',
    width: '200',
    align: 'center'
  },
  {
    field: 'platfromDetails',
    headerName: 'Platfrom Details',
    // width: '200',
    align: 'center'
  },
  {
    field: 'savingCost',
    headerName: 'Saving Cost',
    // width: '200',
    align: 'center',
    valueFormatter: (params) => {
    return `$${(params?.totalCost ?? 0).toFixed(2)}`;
  },
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']?.['totalDuration'] ?? 0}</div>
          <div>On Demand cost/hour: ${(params['value']?.['onDemandPriceValue'] ?? 0).toFixed(2)}</div>
        </>
      }>
        <span>${(params['value']?.['totalCost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  },
  {
    field: 'IdleDays',
    headerName: 'Idle',
    // width: '200',
    align: 'center'
  },
  {
    field: 'LastStoppedTime',
    headerName: 'Last Stopped',
    // width: '200',
    align: 'center'
  },
  {
    field: 'MaximumCPUValue',
    headerName: 'Maximum CPU Value',
    // width: '200',
    align: 'center'
  }
]

// Scheduled Events Columns
export const ec2ColumnsForScheduledEvents = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'scheduleGroupId',
    headerName: 'Group ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceName',
    headerName: 'Name',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '200',
    align: 'center'
  },
  {
    field: 'type',
    headerName: 'Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'stopTime',
    headerName: 'Stop At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Start At',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStop',
    headerName: 'Processed Stop',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStart',
    headerName: 'Processed Start',
    width: '200',
    align: 'center'
  },
  {
    field: 'addedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
]

// Idle Events Columns
export const ec2ColumnsForIdleEvents = [
  {
    field: 'id',
    headerName: 'ID',
    width: '180',
    align: 'center'
  },
  {
    field: 'InstanceId',
    headerName: 'Instance ID',
    width: '180',
    align: 'center'
  },
  {
    field: 'InstanceName',
    headerName: 'Name',
    width: '180',
    align: 'center'
  },
  {
    field: 'IdleDays',
    headerName: 'Idle Days',
    width: '180',
    align: 'center'
  },
  {
    field: 'Region',
    headerName: 'Region',
    width: '180',
    align: 'center'
  },
  {
    field: 'InstanceType',
    headerName: 'Instance Type',
    width: '180',
    align: 'center'
  },
  {
    field: 'AddedBy',
    headerName: 'Scheduled By',
    width: '180',
    align: 'center'
  },
]

// Activity Events Columns
export const ec2ActivityLogColumnsForDataGrid = [
  {
    field: 'id',
    headerName: 'S.no.',
    // width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceName',
    headerName: 'Name',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '200',
    align: 'center'
  },
  {
    field: 'endTime',
    headerName: 'Stopped At',
    width: '200',
    align: 'center'
  },
  {
    field: 'stoppedBy',
    headerName: 'Stopped By',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Started At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startedBy',
    headerName: 'Started By',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'costingDetails',
    headerName: 'Cost',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']['duration'] ?? 0}</div>
          <div>On Demand cost/hour: ${(params['value']['onDemandPriceValue'] ?? 0).toFixed(2)}</div>
        </>
      }>
        <span>${(params['value']['cost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  }
];

// Modification Events Columns
export const ec2ModificationLogColumnsForDataGrid = [
  {
    field: 'id',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  // {
  //   field: 'date',
  //   headerName: 'Date',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'name',
    headerName: 'Name',
    width: '200',
    align: 'center'
  },
  // {
  //   field: 'Instance_state',
  //   headerName: 'Instance State',
  //   width: '200',
  //   align: 'center',
  //   renderCell: (params) => (
  //     <span className={`inventory-state-${params.value}`}>{params.value}</span>
  //   )
  // },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    width: '200',
    align: 'center'
  },
  {
    field: 'Region',
    headerName: 'Region',
    width: '150',
    align: 'center'
  },
  {
    field: 'availabilityZone',
    headerName: 'Availability Zone',
    width: '200',
    align: 'center'
  },
  {
    field: 'publicIPv4DNS',
    headerName: 'Public IPv4 DNS',
    width: '200',
    align: 'center'
  },
  {
    field: 'publicIPv4Address',
    headerName: 'Public IPv4 Address',
    width: '200',
    align: 'center'
  },
  {
    field: 'iPv6IPs',
    headerName: 'IPv6 IPs',
    width: '200',
    align: 'center'
  },
  {
    field: 'monitoring',
    headerName: 'Monitoring',
    width: '200',
    align: 'center'
  },
  {
    field: 'securityGroupName',
    headerName: 'Security group name',
    width: '200',
    align: 'center'
  },
  {
    field: 'keyName',
    headerName: 'Key Name',
    width: '200',
    align: 'center'
  },
  {
    field: 'launchTime',
    headerName: 'Launch Time',
    width: '200',
    align: 'center'
  },
  {
    field: 'platfromDetails',
    headerName: 'Platfrom Details',
    width: '200',
    align: 'center'
  }
];

// Modification Events Columns for Changes table
export const ec2ModificationChangesColumns = [
  {
    field: 'id',
    headerName: 'Instance ID',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  // {
  //   field: 'date',
  //   headerName: 'Date',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'name',
    headerName: 'Name',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  // {
  //   field: 'Instance_state',
  //   headerName: 'Instance State',
  //   width: '200',
  //   align: 'center',
  //   renderCell: (params) => (
  //     <>
  //       {params['value'] && params['value']['classname'] && (
  //         <Tooltip title={
  //           <div>Old Value: {params['value']['oldValue']}</div>
  //         }>
  //           <span className={params['value']['classname']} >
  //             {params['value']['updatedValue']}
  //           </span>
  //         </Tooltip>
  //       )}

  //       {params['value'] && !params['value']['classname'] && (params['value'])}
  //     </>
  //   )
  // },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'Region',
    headerName: 'Region',
    width: '150',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'availabilityZone',
    headerName: 'Availability Zone',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'publicIPv4DNS',
    headerName: 'Public IPv4 DNS',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'publicIPv4Address',
    headerName: 'Public IPv4 Address',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'iPv6IPs',
    headerName: 'IPv6 IPs',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'monitoring',
    headerName: 'Monitoring',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'securityGroupName',
    headerName: 'Security group name',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'keyName',
    headerName: 'Key Name',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'launchTime',
    headerName: 'Launch Time',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'platfromDetails',
    headerName: 'Platfrom Details',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  // {
  //   field: 'updatedValue',
  //   headerName: 'updatedValue',
  //   width: '300',
  //   align: 'center',
  //   renderCell: (params) => (
  //     // console.log('dddddddddddd', params)
  //     params['value'] && <Tooltip title={
  //       <div>Old Value: {params['value']['oldValue']}</div>
  //     }>
  //       <span className={params['value']['classname']} >
  //         {params['value']['updatedKey']}: {params['value']['updatedValue']}
  //       </span>
  //     </Tooltip>
  //   )
  // },
]

//=================================================
// RDS Columns
//================================================= 
// Inventory Report
export const rdsColumnsForInventoryReports = [
  {
    field: 'id',
    headerName: 'ID',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance ID',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: params => (
      <span>{params['row']['costingDetails'][0]['instanceType'] ?? 0.000}</span>
    )
  },
  {
    field: 'multiAZ',
    headerName: 'MultiAZ',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: params => (
      <span>{(params['row']['costingDetails'][0]['multiAZ'] ?? false).toString()}</span>
    )
  },
  {
    field: 'region',
    headerName: 'Region',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  // {
  //   field: 'instanceName',
  //   headerName: 'Name',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'costingDetails',
    headerName: 'On Demand cost/hour',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: params => (
      <Tooltip title={
        params['value'].map(c => (
          <div>{c['instanceId'] ?? ''}: ${c['onDemandPriceValue'] ?? 0}</div>
        ))
      }>
        <span>${params['row']['totalOnDemandPriceValue'] ?? 0.000}</span>
      </Tooltip>
    )
  },
  {
    field: 'duration',
    headerName: 'Stopped hours',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Savings cost',
    // width: '200',
    flex: 1,
    align: 'center'
  },
]

// Scheduled Events Columns
export const rdsColumnsForScheduledEvents = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '150',
    align: 'center'
  },
  {
    field: 'type',
    headerName: 'Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'stopTime',
    headerName: 'Stop At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Start At',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStop',
    headerName: 'Processed Stop',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStart',
    headerName: 'Processed Start',
    width: '200',
    align: 'center'
  },
  {
    field: 'addedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
]

// Inventory Instances Columns
export const rdsColumnsForInventory = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center',
    // renderCell: (params) => (
    //   params['row']['type'] === 'cluster' ? params['value'] : '-'
    // )
  },
  {
    field: 'DBClusterIdentifier',
    headerName: 'Cluster ID',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      params['row']['type'] === 'cluster' ? params['value'] : '-'
    )
  },
  {
    field: 'DBClusterMembers',
    headerName: 'Instance ID',
    width: '250',
    align: 'center',
    renderCell: (params) => (
      <List dense style={{
        maxHeight: '65px',
        overflowY: 'auto'
      }}>
        {params['value']?.map(instance => (
          <ListItem key={instance['DBInstanceIdentifier']} style={{
            height: '20px'
          }}>
            <ListItemText>&#8226;&nbsp;{instance['DBInstanceIdentifier']}</ListItemText>
          </ListItem>
        ))}
      </List>
    )
  },
  {
    field: 'Engine',
    headerName: 'Engine',
    width: '200',
    align: 'center'
  },
  {
    field: 'Status',
    headerName: 'Status',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <span className={`inventory-state-${params.value}`}>{params.value}</span>
    )
  },
  {
    field: 'Region',
    headerName: 'Region',
    width: '120',
    align: 'center'
  },
  {
    field: 'VpcSecurityGroupId',
    headerName: 'Vpc Security Group Id',
    width: '200',
    align: 'center'
  },
  {
    field: 'MultiAZ',
    headerName: 'MultiAZ',
    // width: '200',
    align: 'center'
  },
  {
    field: 'MaximumCPUValue',
    headerName: 'Max CPU',
    // width: '200',
    align: 'center'
  },
  {
    field: 'IdleDays',
    headerName: 'Idle',
    width: '200',
    align: 'center'
  },
  {
    field: 'savingCost',
    headerName: 'Saving Cost',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']?.['totalDuration'] ?? 0}</div>
          <div>On Demand cost/hour: ${(params['value']?.['onDemandPriceValue'] ?? 0).toFixed(2)}</div>
        </>
      }>
        <span>${(params['value']?.['totalCost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  }
];

// Activity Events Columns
export const rdsColumnsForActivityevents = [
  {
    field: 'id',
    headerName: 'S.no.',
    // width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance Id',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '150',
    align: 'center'
  },
  // {
  //   field: 'instanceName',
  //   headerName: 'Instance Name',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'endTime',
    headerName: 'Stopped At',
    width: '200',
    align: 'center'
  },
  {
    field: 'stoppedBy',
    headerName: 'Stopped By',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Started At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startedBy',
    headerName: 'Started By',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'costingDetails',
    headerName: 'Cost',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']['duration'] ?? 0}</div>
          <div>On Demand cost/hour: ${(params['value']['onDemandPriceValue'] ?? 0).toFixed(2)}</div>
        </>
      }>
        <span>${(params['value']['cost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  }
];

// Modification Events Columns
export const rdsColumnsForModificationEvents = [
  {
    field: 'id',
    headerName: 'S.no',
    width: '100',
    align: 'center'
  },
  {
    field: 'DBIdentifier',
    headerName: 'DB Identifier',
    width: '200',
    align: 'center'
  },
  // {
  //   field: 'Date',
  //   headerName: 'Date',
  //   width: '200',
  //   align: 'center'
  // },
  // {
  //   field: 'Status',
  //   headerName: 'Status',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'Engine',
    headerName: 'Engine',
    width: '200',
    align: 'center'
  },
  {
    field: 'Size',
    headerName: 'Size',
    width: '200',
    align: 'center'
  },
  {
    field: 'Region',
    headerName: 'Region',
    width: '200',
    align: 'center'
  },
  {
    field: 'VPC',
    headerName: 'VPC',
    width: '200',
    align: 'center'
  },
  {
    field: 'MultiAZ',
    headerName: 'MultiAZ',
    width: '200',
    align: 'center'
  }
];

// Modification Events Columns for Changes table
export const rdsModificationChangesColumns = [
  {
    field: 'id',
    headerName: 'S.no',
    width: '100',
    align: 'center'
  },
  {
    field: 'DBIdentifier',
    headerName: 'DB Identifier',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  // {
  //   field: 'Status',
  //   headerName: 'Status',
  //   width: '200',
  //   align: 'center',
  //   renderCell: (params) => (
  //     <>
  //       {params['value'] && params['value']['classname'] && <Tooltip title={
  //         <div>Old Value: {params['value']['oldValue']}</div>
  //       }>
  //         <span className={params['value']['classname']} >
  //           {params['value']['updatedValue']}
  //         </span>
  //       </Tooltip>}

  //       {params['value'] && !params['value']['classname'] && (params['value'])}
  //     </>
  //   )
  // },
  {
    field: 'Engine',
    headerName: 'Engine',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'Size',
    headerName: 'Size',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'Region',
    headerName: 'Region',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'VPC',
    headerName: 'VPC',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'MultiAZ',
    headerName: 'MultiAZ',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  // {
  //   field: 'updatedValue',
  //   headerName: 'updatedValue',
  //   width: '300',
  //   align: 'center',
  //   renderCell: (params) => (
  //     // console.log('dddddddddddd', params)
  //     params['value'] && <Tooltip title={
  //       <div>Old Value: {params['value']['oldValue']}</div>
  //     }>
  //       <span className={params['value']['classname']} >
  //         {params['value']['updatedKey']}: {params['value']['updatedValue']}
  //       </span>
  //     </Tooltip>
  //   )
  // },
]

// Idle Events Columns
export const rdsColumnsForIdleEvents = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'InstanceId',
    headerName: 'Instance ID',
    width: '300',
    align: 'center'
  },
  {
    field: 'IdleDays',
    headerName: 'Idle Days',
    width: '300',
    align: 'center'
  },
  {
    field: 'Region',
    headerName: 'Region',
    width: '250',
    align: 'center'
  },
  {
    field: 'AddedBy',
    headerName: 'Scheduled By',
    width: '250',
    align: 'center'
  },
]

//=================================================
// ASG Columns
//================================================= 
// Inventory Reports Columns
export const asgColumnsForInventoryReports = [
  {
    field: 'id',
    headerName: 'Instance ID',
    width: '300',
    // flex: 1,
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'duration',
    headerName: 'Stopped hours',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Savings cost',
    // width: '200',
    flex: 1,
    align: 'center'
  },
]

// Inventory Instances Columns
export const asgColumnsForInventory = [
  {
    field: 'id',
    headerName: 'Name',
    width: '300',
    // flex: 1,
    align: 'center'
  },
  {
    field: 'Region',
    headerName: 'Region',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'MinSize',
    headerName: 'MinSize',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'MaxSize',
    headerName: 'MaxSize',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'DesiredCapacity',
    headerName: 'Desired Capacity',
    // width: '200',
    flex: 1,
    align: 'center'
  }
]

// Activity Events Columns
export const asgActivityLogColumns = [
  {
    field: 'id',
    headerName: 'S.no.',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance ID',
    // width: '200',
    flex: 3,
    align: 'center'
  },
  {
    field: 'instanceName',
    headerName: 'Name',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'endTime',
    headerName: 'Stopped At',
    // width: '200',
    flex: 2,
    align: 'center'
  },
  {
    field: 'stoppedBy',
    headerName: 'Stopped By',
    // width: '200',
    flex: 2,
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Started At',
    // width: '200',
    flex: 2,
    align: 'center'
  },
  {
    field: 'startedBy',
    headerName: 'Started By',
    // width: '200',
    flex: 2,
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'costingDetails',
    headerName: 'Cost',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: (params) => (
      <span onClick={(e) => params['row']['asgCostClickedComponent'](e, params['row'])}>
        ${(params['value']['totalCost'] ?? 0).toFixed(2)}
      </span>
    )
  }
];

// Modification Events Columns
export const asgModificationLogColumns = [
  {
    field: 'id',
    headerName: 'Instance ID',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'AutoScalingGroupName',
    headerName: 'ASG Name',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'InstanceType',
    headerName: 'Type',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'AvailabilityZone',
    headerName: 'Availability Zone',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'LifecycleState',
    headerName: 'Lifecycle State',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'HealthStatus',
    headerName: 'Health Status',
    // width: '200',
    flex: 1,
    align: 'center'
  }
];

// Modification Events Columns for Changes table
export const asgModificationLogColumnsForChanges = [
  {
    field: 'id',
    headerName: 'Instance ID',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'name',
    headerName: 'ASG Name',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'InstanceType',
    headerName: 'Type',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'AvailabilityZone',
    headerName: 'Availability Zone',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'LifecycleState',
    headerName: 'Lifecycle State',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  },
  {
    field: 'HealthStatus',
    headerName: 'Health Status',
    // width: '200',
    flex: 1,
    align: 'center',
    renderCell: (params) => (
      <>
        {params['value'] && params['value']['classname'] && <Tooltip title={
          <div>Old Value: {params['value']['oldValue']}</div>
        }>
          <span className={params['value']['classname']} >
            {params['value']['updatedValue']}
          </span>
        </Tooltip>}

        {params['value'] && !params['value']['classname'] && (params['value'])}
      </>
    )
  }
];

// ===================================================
// Tag Based Inventory
// ===================================================
// Scheduled Events Columns
export const tagColumnsForScheduledEvents = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'scheduleGroupId',
    headerName: 'Group ID',
    width: '200',
    align: 'center'
  },
  // {
  //   field: 'instanceId',
  //   headerName: 'Instance ID',
  //   width: '200',
  //   align: 'center'
  // },
  // {
  //   field: 'instanceName',
  //   headerName: 'Name',
  //   width: '200',
  //   align: 'center'
  // },
  // {
  //   field: 'region',
  //   headerName: 'Region',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'serviceType',
    headerName: 'Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'stopTime',
    headerName: 'Stop At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Start At',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStop',
    headerName: 'Processed Stop',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStart',
    headerName: 'Processed Start',
    width: '200',
    align: 'center'
  },
  {
    field: 'addedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
  {
    field: 'tagKey',
    headerName: 'Tag Key',
    width: '200',
    align: 'center'
  },
    {
    field: 'tagValues',
    headerName: 'Tag Value(s)',
    width: '200',
    // flex: 1,
    align: 'center',
    renderCell: (params) => (params['value'].join(', '))
  }
]

//=================================================
// EBS Columns
//================================================= 
export const EBScolumns = [
  // { id: 'select', label: 'Select', minWidth: 120, align: 'center' },
  { id: 'Name', label: 'Name', minWidth: 250 },
  { id: 'Volumeid', label: 'Volume ID', minWidth: 200, align: 'center' },
  { id: 'Type', label: 'Type', minWidth: 150, align: 'center' },
  { id: 'Size', label: 'Size', minWidth: 150, align: 'center' },
  { id: 'IOPS', label: 'IOPS', minWidth: 200, align: 'center' },
  { id: 'Throughput', label: 'Throughput', minWidth: 250, align: 'center' },
  { id: 'Created', label: 'Created', minWidth: 250, align: "center" },
  { id: 'Availabilityzone', label: 'Availability Zone', minWidth: 200, align: 'center' },
  { id: 'Volumestate', label: 'Volume state', minWidth: 200, align: 'center' },
  { id: 'Attachedresources', label: 'Attached resources', minWidth: 300, align: 'center' },
  { id: 'Encryption', label: 'Encryption', minWidth: 200, align: 'center' },
  { id: 'MultiAttachenabled', label: 'Multi-Attach enabled', minWidth: 250, align: 'right' },
];

export const EBSAvailablecolumns = [
  // { id: 'select', label: 'Select', minWidth: 120, align: 'center' },
  { id: 'Name', label: 'Name', minWidth: 250 },
  { id: 'Volumeid', label: 'Volume ID', minWidth: 200, align: 'center' },
  { id: 'Type', label: 'Type', minWidth: 150, align: 'center' },
  { id: 'Size', label: 'Size', minWidth: 150, align: 'center' },
  { id: 'IOPS', label: 'IOPS', minWidth: 200, align: 'center' },
  { id: 'Throughput', label: 'Throughput', minWidth: 250, align: 'center' },
  { id: 'Created', label: 'Created', minWidth: 250, align: "center" },
  { id: 'Availabilityzone', label: 'Availability Zone', minWidth: 200, align: 'center' },
  { id: 'Volumestate', label: 'Volume state', minWidth: 200, align: 'center' },
  { id: 'Attachedresources', label: 'Attached resources', minWidth: 300, align: 'center' },
  { id: 'Encryption', label: 'Encryption', minWidth: 200, align: 'center' },
  { id: 'MultiAttachenabled', label: 'Multi-Attach enabled', minWidth: 250, align: 'center' },
  { id: 'OnDemandMonthlyStoragePriceValue', label: 'Monthly EBS Cost', minWidth: 250, align: 'center' },
  { id: 'OnDemandMonthlyIOPSPriceValue', label: 'Monthly IOPS Cost', minWidth: 250, align: 'right' },

];

export const EBSChangescolumns = [
  // { id: 'select', label: 'Select', minWidth: 120, align: 'center' },
  { id: 'Date', label: 'Date', minWidth: 170 },
  { id: 'Name', label: 'Name', minWidth: 250 },
  { id: 'Volumeid', label: 'Volume ID', minWidth: 200, align: 'center' },
  { id: 'Type', label: 'Type', minWidth: 150, align: 'center' },
  { id: 'Size', label: 'Size', minWidth: 150, align: 'center' },
  { id: 'IOPS', label: 'IOPS', minWidth: 200, align: 'center' },
  { id: 'Throughput', label: 'Throughput', minWidth: 250, align: 'center' },
  { id: 'Created', label: 'Created', minWidth: 250, align: "center" },
  { id: 'Availabilityzone', label: 'Availability Zone', minWidth: 200, align: 'center' },
  { id: 'Volumestate', label: 'Volume state', minWidth: 200, align: 'center' },
  { id: 'Attachedresources', label: 'Attached resources', minWidth: 300, align: 'center' },
  { id: 'Encryption', label: 'Encryption', minWidth: 200, align: 'center' },
  { id: 'MultiAttachenabled', label: 'Multi-Attach enabled', minWidth: 250, align: 'right' },
];

//=================================================
// Lambda Columns
//================================================= 
export const Lambdacolumns = [
  // { id: 'select', label: 'Select', minWidth: 120, align: 'center' },
  { id: 'Name', label: 'Name', minWidth: 170 },
  { id: 'Description', label: 'Description', minWidth: 300, align: 'center' },
  { id: 'Packagetype', label: 'Package Type', minWidth: 170, align: 'center' },
  { id: 'Runtime', label: 'Runtime', minWidth: 170, align: 'center' },
  { id: 'Lastmodified', label: 'Last modified', minWidth: 250, align: 'right' },

]

export const LambdaChangescolumns = [
  { id: 'Date', label: 'Date', minWidth: 170 },
  { id: 'Name', label: 'Name', minWidth: 200 },
  { id: 'Description', label: 'Description', minWidth: 300, align: 'center' },
  { id: 'Packagetype', label: 'Package Type', minWidth: 170, align: 'center' },
  { id: 'Runtime', label: 'Runtime', minWidth: 170, align: 'center' },
  { id: 'Lastmodified', label: 'Last modified', minWidth: 250, align: 'right' },

]

export const InstanceActionList = {
  START: 'start',
  STOP: 'stop'
}

// ===================================
// Azure Inventory
// ===================================

// VM Inventory Instances Columns
export const vmInventoryColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center',
    // renderCell: (params) => (
    //   params['row']['type'] === 'cluster' ? params['value'] : '-'
    // )
  },
  {
    field: 'name',
    headerName: 'Name',
    width: '200',
    align: 'center',
  },
  {
    field: 'vmStatus',
    headerName: 'Status',
    width: '250',
    align: 'center',
  },
  {
    field: 'location',
    headerName: 'Location',
    width: '200',
    align: 'center'
  },
  {
    field: 'tags',
    headerName: 'Tags',
    width: 320,
    align: 'left',
    sortable: false,
    valueFormatter: (params) => {
      const tags = params || [];
      if (!tags.length) return 'No tags';
      return tags.map(tag => `${tag.Key}: ${tag.Value}`).join(' | ');
    },
    renderCell: (params) => {
      const tags = params.value || [];

      if (!tags || tags.length === 0) {
        return (
          <span style={{ color: '#9ca3af', fontStyle: 'italic', fontSize: '13px' }}>
            No tags
          </span>
        );
      }

      return (
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0.25rem',
          maxWidth: '100%',
          width: '100%',
          height: '100%',
          alignItems: 'center'
        }}>
          {tags.map((tag, index) => (
            <div
              key={index}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.125rem 0.5rem',
                borderRadius: '0.25rem',
                fontSize: '0.75rem',
                fontWeight: 500,
                backgroundColor: '#f3f4f6',
                color: '#374151',
                border: '1px solid #e5e7eb',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                height: '24px',
                lineHeight: '1',
                flexShrink: 0,
                margin: '2px 0',
              }}
              title={`${tag.Key}: ${tag.Value}`}
            >
              <span style={{ fontWeight: 600, marginRight: '0.25rem', color: '#111827' }}>
                {tag.Key}
              </span>
              <span style={{ color: '#6b7280' }}>
                : {tag.Value}
              </span>
            </div>
          ))}
        </div>
      );
    }
  },
  {
    field: 'provisioningState',
    headerName: 'Provisioning State',
    // width: '200',
    align: 'center',
  },
  {
    field: 'diskSizeGB',
    headerName: 'Disk Size (GB)',
    width: '120',
    align: 'center'
  },
  {
    field: 'resourceGroup',
    headerName: 'Resource Group',
    width: '200',
    align: 'center'
  },
  {
    field: 'vmSize',
    headerName: 'Size',
    width: '200',
    align: 'center'
  },
  {
    field: 'osType',
    headerName: 'OS',
    width: '200',
    align: 'center'
  },
  {
    field: 'peakCpuValue',
    headerName: 'Peak CPU Value',
    width: '200',
    align: 'center'
  },
  {
    field: 'timeCreated',
    headerName: 'Created At',
    width: '200',
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Saving Cost',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']?.['totalDuration'] ?? 0}</div>
          <div>On Demand cost/hour: ${(params['value']?.['onDemandPriceValue'] ?? 0).toFixed(2)}</div>
        </>
      }>
        <span>${(params['value']?.['totalCost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  }
];

export const vmScheduledEventColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceName',
    headerName: 'Name',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '200',
    align: 'center'
  },
  {
    field: 'serviceType',
    headerName: 'Type',
    width: '200',
    align: 'center'
  },
  {
    field: 'stopTime',
    headerName: 'Stop At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Start At',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStop',
    headerName: 'Processed Stop',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStart',
    headerName: 'Processed Start',
    width: '200',
    align: 'center'
  },
  {
    field: 'addedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
  {
    field: 'type',
    headerName: 'Scheduled Type',
    width: '200',
    align: 'center'
  },
  {
    field: 'scheduleGroupId',
    headerName: 'Group Id',
    width: '200',
    align: 'center'
  },
]

export const vmInventoryReportsColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'vmName',
    headerName: 'Name',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'vmSize',
    headerName: 'Size',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'location',
    headerName: 'Location',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'onDemandPriceValue',
    headerName: 'On Demand cost/hour',
    // width: '200',
    flex: 1,
    align: 'center',
  },
  {
    field: 'duration',
    headerName: 'Stopped hours',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Savings cost',
    // width: '200',
    flex: 1,
    align: 'center'
  },
]

export const vmInventoryIdleEventColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'InstanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'IdleDays',
    headerName: 'Idle Days',
    // width: '200',
    align: 'center'
  },
  {
    field: 'Region',
    headerName: 'Region',
    // width: '200',
    align: 'center'
  },
  {
    field: 'AddedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
]

// Activity Events Columns
export const vmInventoryActivityEventColumnList = [
  {
    field: 'id',
    headerName: 'S.no.',
    // width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance Id',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '150',
    align: 'center'
  },
  // {
  //   field: 'instanceName',
  //   headerName: 'Instance Name',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'endTime',
    headerName: 'Stopped At',
    width: '200',
    align: 'center'
  },
  {
    field: 'stoppedBy',
    headerName: 'Stopped By',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Started At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startedBy',
    headerName: 'Started By',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'costingDetails',
    headerName: 'Cost',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']['duration'] ?? 0}</div>
          <div>On Demand cost/hour: ${(params['value']['onDemandPriceValue'] ?? 0).toFixed(2)}</div>
        </>
      }>
        <span>${(params['value']['cost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  }
];

// VMSS Inventory Instances Columns
export const vmssInventoryColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center',
    // renderCell: (params) => (
    //   params['row']['type'] === 'cluster' ? params['value'] : '-'
    // )
  },
  {
    field: 'vmssName',
    headerName: 'Name',
    width: '200',
    align: 'center',
  },
  {
    field: 'location',
    headerName: 'Location',
    width: '200',
    align: 'center'
  },
  {
    field: 'provisioningState',
    headerName: 'Provisioning State',
    // width: '200',
    align: 'center',
  },
  {
    field: 'skuName',
    headerName: 'SKU',
    width: '120',
    align: 'center'
  },
  {
    field: 'resourceGroup',
    headerName: 'Resource Group',
    width: '200',
    align: 'center'
  },
  {
    field: 'currentCapacity',
    headerName: 'Capacity',
    width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Minimum: {params['row']?.['minCapacity'] ?? 0}</div>
          <div>Maximum: {params['row']?.['maxCapacity'] ?? 0}</div>
          <div>Default: {params['row']?.['defaultCapacity'] ?? 0}</div>
        </>
      }>
        <span>{params['value']}</span>
      </Tooltip>
    )
  },
  {
    field: 'osType',
    headerName: 'OS',
    width: '200',
    align: 'center'
  },
  {
    field: 'peakCpuValue',
    headerName: 'Peak CPU Value',
    width: '200',
    align: 'center'
  },
  {
    field: 'timeCreated',
    headerName: 'Created At',
    width: '200',
    align: 'center'
  },
  {
    field: 'scalingMode',
    headerName: 'Scaling Mode',
    width: '200',
    align: 'center'
  },
  {
    field: 'orchestrationMode',
    headerName: 'Orchestration Mode',
    width: '200',
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Saving Cost',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']['totalDuration'] ?? 0}</div>
          <div>On Demand cost/hour: ${(params['value']['onDemandPriceValue'] ?? 0).toFixed(2)}</div>
        </>
      }>
        <span>${(params['value']['totalCost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  }
];

export const vmssScheduledEventColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceName',
    headerName: 'Name',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '200',
    align: 'center'
  },
  {
    field: 'serviceType',
    headerName: 'Type',
    width: '200',
    align: 'center'
  },
  {
    field: 'stopTime',
    headerName: 'Stop At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Start At',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStop',
    headerName: 'Processed Stop',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStart',
    headerName: 'Processed Start',
    width: '200',
    align: 'center'
  },
  {
    field: 'addedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
  {
    field: 'type',
    headerName: 'Scheduled Type',
    width: '200',
    align: 'center'
  },
  {
    field: 'scheduleGroupId',
    headerName: 'Group Id',
    width: '200',
    align: 'center'
  },
]

export const vmssInventoryReportsColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  // {
  //   field: 'vmName',
  //   headerName: 'Name',
  //   // width: '200',
  //   flex: 1,
  //   align: 'center'
  // },
  // {
  //   field: 'vmSize',
  //   headerName: 'Size',
  //   // width: '200',
  //   flex: 1,
  //   align: 'center'
  // },
  // {
  //   field: 'location',
  //   headerName: 'Location',
  //   // width: '200',
  //   flex: 1,
  //   align: 'center'
  // },
  {
    field: 'region',
    headerName: 'Region',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  // {
  //   field: 'onDemandPriceValue',
  //   headerName: 'On Demand cost/hour',
  //   // width: '200',
  //   flex: 1,
  //   align: 'center',
  // },
  {
    field: 'duration',
    headerName: 'Stopped hours',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Savings cost',
    // width: '200',
    flex: 1,
    align: 'center'
  },
]

export const vmssInventoryIdleEventColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'InstanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'IdleDays',
    headerName: 'Idle Days',
    // width: '200',
    align: 'center'
  },
  {
    field: 'Region',
    headerName: 'Region',
    // width: '200',
    align: 'center'
  },
  {
    field: 'AddedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
];

// Activity Events Columns
export const vmssInventoryActivityEventColumnList = [
  {
    field: 'id',
    headerName: 'S.no.',
    // width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance Id',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '150',
    align: 'center'
  },
  // {
  //   field: 'instanceName',
  //   headerName: 'Instance Name',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'endTime',
    headerName: 'Stopped At',
    width: '200',
    align: 'center'
  },
  {
    field: 'stoppedBy',
    headerName: 'Stopped By',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Started At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startedBy',
    headerName: 'Started By',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'costingDetails',
    headerName: 'Cost',
    width: 140,
    align: 'center',
    renderCell: (params) => {
      const costing = params.row?.costingDetails || params.value;

      // For VMSS - use totalCost and instanceCostingDetails[0]
      const totalCost = costing?.totalCost ?? 0;
      const instanceDetail = costing?.instanceCostingDetails?.[0] || {};

      const displayCost = totalCost;
      const duration = instanceDetail.duration ?? costing?.totalDuration ?? 0;
      const onDemandPrice = instanceDetail.onDemandPriceValue ?? 0;

      return (
        <Tooltip 
          title={
            <>
              <div><strong>Total Duration:</strong> {duration} hrs</div>
              <div><strong>On Demand Price/hr:</strong> ${onDemandPrice.toFixed(3)}</div>
            </>
          }
          arrow
        >
          <span>
            ${Number(displayCost).toFixed(2)}
          </span>
        </Tooltip>
      );
    }
  }
];

// Azure DB Inventory Instances Columns
export const dbInventoryColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center',
    // renderCell: (params) => (
    //   params['row']['type'] === 'cluster' ? params['value'] : '-'
    // )
  },
  {
    field: 'serverName',
    headerName: 'Name',
    width: '200',
    align: 'center',
  },
  {
    field: 'availabilityZone',
    headerName: 'Zone',
    width: '200',
    align: 'center',
  },
  {
    field: 'location',
    headerName: 'Location',
    width: '200',
    align: 'center'
  },
  {
    field: 'state',
    headerName: 'State',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <span className={`inventory-state-${params.value?.toLocaleLowerCase()}`}>{params.value}</span>
    )
  },
  {
    field: 'skuName',
    headerName: 'SKU',
    width: '120',
    align: 'center'
  },
  {
    field: 'skuTier',
    headerName: 'Tier',
    width: '120',
    align: 'center'
  },
  {
    field: 'resourceGroup',
    headerName: 'Resource Group',
    width: '200',
    align: 'center'
  },
  {
    field: 'peakCpuValue',
    headerName: 'Peak CPU Value',
    width: '200',
    align: 'center'
  },
  {
    field: 'engineType',
    headerName: 'Type',
    width: '200',
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Saving Cost',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']?.['totalDuration'] ?? 0}</div>
          {/* <div>On Demand cost/hour: ${(params['value']['onDemandPriceValue'] ?? 0).toFixed(2)}</div> */}
        </>
      }>
        <span>${(params['value']?.['totalCost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  }
];

export const dbScheduledEventColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceName',
    headerName: 'Name',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '200',
    align: 'center'
  },
  {
    field: 'serviceType',
    headerName: 'Type',
    width: '200',
    align: 'center'
  },
  {
    field: 'stopTime',
    headerName: 'Stop At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Start At',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStop',
    headerName: 'Processed Stop',
    width: '200',
    align: 'center'
  },
  {
    field: 'processedStart',
    headerName: 'Processed Start',
    width: '200',
    align: 'center'
  },
  {
    field: 'addedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
  {
    field: 'type',
    headerName: 'Scheduled Type',
    width: '200',
    align: 'center'
  },
  {
    field: 'scheduleGroupId',
    headerName: 'Group Id',
    width: '200',
    align: 'center'
  },
]

export const dbInventoryReportsColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  // {
  //   field: 'vmName',
  //   headerName: 'Name',
  //   // width: '200',
  //   flex: 1,
  //   align: 'center'
  // },
  // {
  //   field: 'vmSize',
  //   headerName: 'Size',
  //   // width: '200',
  //   flex: 1,
  //   align: 'center'
  // },
  // {
  //   field: 'location',
  //   headerName: 'Location',
  //   // width: '200',
  //   flex: 1,
  //   align: 'center'
  // },
  {
    field: 'region',
    headerName: 'Region',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  // {
  //   field: 'onDemandPriceValue',
  //   headerName: 'On Demand cost/hour',
  //   // width: '200',
  //   flex: 1,
  //   align: 'center',
  // },
  {
    field: 'duration',
    headerName: 'Stopped hours',
    // width: '200',
    flex: 1,
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Savings cost',
    // width: '200',
    flex: 1,
    align: 'center'
  },
]

export const dbInventoryIdleEventColumnList = [
  {
    field: 'id',
    headerName: 'ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'InstanceId',
    headerName: 'Instance ID',
    width: '200',
    align: 'center'
  },
  {
    field: 'IdleDays',
    headerName: 'Idle Days',
    // width: '200',
    align: 'center'
  },
  {
    field: 'Region',
    headerName: 'Region',
    // width: '200',
    align: 'center'
  },
  {
    field: 'AddedBy',
    headerName: 'Scheduled By',
    width: '200',
    align: 'center'
  },
];

// Activity Events Columns
export const dbInventoryActivityEventColumnList = [
  {
    field: 'id',
    headerName: 'S.no.',
    // width: '200',
    align: 'center'
  },
  {
    field: 'instanceId',
    headerName: 'Instance Id',
    width: '200',
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    width: '150',
    align: 'center'
  },
  // {
  //   field: 'instanceName',
  //   headerName: 'Instance Name',
  //   width: '200',
  //   align: 'center'
  // },
  {
    field: 'endTime',
    headerName: 'Stopped At',
    width: '200',
    align: 'center'
  },
  {
    field: 'stoppedBy',
    headerName: 'Stopped By',
    width: '200',
    align: 'center'
  },
  {
    field: 'startTime',
    headerName: 'Started At',
    width: '200',
    align: 'center'
  },
  {
    field: 'startedBy',
    headerName: 'Started By',
    width: '200',
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    // width: '200',
    align: 'center'
  },
  {
    field: 'costingDetails',
    headerName: 'Cost',
    // width: '200',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={
        <>
          <div>Total Duration: {params['value']['duration'] ?? 0}</div>
          <div>On Demand cost/hour: ${(params['value']['onDemandPriceValue'] ?? 0).toFixed(2)}</div>
        </>
      }>
        <span>${(params['value']['cost'] ?? 0).toFixed(2)}</span>
      </Tooltip>
    )
  }
];

// Tag Inventory Report
export const tagColumnsForInventoryReports = [
  {
    field: 'id',
    headerName: 'Instance ID',
    flex: 1,
    align: 'center'
  },
  {
    field: 'instanceName',
    headerName: 'Name',
    flex: 1,
    align: 'center'
  },
  {
    field: 'instanceType',
    headerName: 'Instance Type',
    flex: 1,
    align: 'center'
  },
  {
    field: 'region',
    headerName: 'Region',
    flex: 1,
    align: 'center'
  },
  {
    field: 'onDemandPriceValue',
    headerName: 'On Demand cost/hour',
    flex: 1,
    align: 'center',
  },
  {
    field: 'duration',
    headerName: 'Stopped hours',
    flex: 1,
    align: 'center'
  },
  {
    field: 'totalSavingCost',
    headerName: 'Savings cost',
    flex: 1,
    align: 'center'
  },
]